export default "__VITE_ASSET__f45348ed__"